import { resolvePushDisplayTitle } from './pushNotificationPresentation';
import { pickNotificationId } from './pickNotificationId';
import {
  pickNotificationEventId,
  resolvePortalNotificationPath,
} from './portalNotificationRouting';
/** @typedef {import('firebase/messaging').MessagePayload} MessagePayload */

/** Stable OS notification tag — keep in sync with public/push-notification-display.js */
export const resolvePushNotificationTag = (data = {}) => {
  const eventId =
    (data.eventId && String(data.eventId).trim()) ||
    (data.event_id && String(data.event_id).trim()) ||
    (data.targetId && String(data.targetId).trim()) ||
    '';

  return (
    (data.messageId && String(data.messageId).trim()) ||
    (data.notificationId && String(data.notificationId).trim()) ||
    (data.notification_id && String(data.notification_id).trim()) ||
    (data.id && String(data.id).trim()) ||
    (data.type && String(data.type).trim()) ||
    eventId ||
    'surespace-push'
  );
};

export const parseFcmPushPayload = (payload = {}) => {
  const notification = payload?.notification ?? {};
  const data = { ...(payload?.data ?? {}) };

  if (payload?.fcmOptions?.link && !data.url && !data.link) {
    data.link = payload.fcmOptions.link;
  }

  const type = data.type || data.notificationType || null;

  return {
    title: String(resolvePushDisplayTitle(data, notification)),
    body: notification.body || data.body || data.message || '',
    icon: notification.icon || data.icon || undefined,
    data,
    hasNotificationPayload: Boolean(notification?.title || notification?.body),
    eventId: pickNotificationEventId({ data }),
    type,
    notificationId: pickNotificationId({ data }),
  };
};

export const resolveFcmPayloadPath = (payload = {}, userRole = null) => {
  const parsed = parseFcmPushPayload(payload);
  return resolvePortalNotificationPath(
    {
      ...parsed.data,
      type: parsed.type,
      eventId: parsed.eventId,
    },
    userRole,
  );
};

export const FCM_SW_MESSAGE_TYPE = 'FCM_NOTIFICATION_CLICK';
export const FCM_SW_SHOW_NOTIFICATION = 'FCM_SW_SHOW_NOTIFICATION';
// ALERT_SOUND_DISABLED — export const FCM_SW_PLAY_NOTIFICATION_SOUND = 'FCM_SW_PLAY_NOTIFICATION_SOUND';
